import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	micado: {
		display: "flex",
		order: 2,
		[theme.breakpoints.up("md")]: {
			order: 1
		},
		"& a": {
			display: "block"
		},
		"& img": {
			display: "block"
		}
	}
}));

export default styles;
